import React,{useRef,useState,useEffect} from "react";
import Wrp from '../../../hoc/Wrp/Wrp';
import Icons from "../../../Components/Icons/Icons";
import Modal from "react-bootstrap/Modal";
import Inputs from '../../../Components/Inputs/Inputs';
import {getUserInfo} from '../../../Utils/UserFunctions';
import {isSet} from '../../../Utils/CommonFunctions';

const DirectoryMapping = (props) => {
	const {documentList,isModalOpen,toggleDirectory,documentValueHandler,documentValue} = props;
	const [directoryValue,setDirectoryValue] = useState({
    name:'',
    value:''
  }); 
  const [isDirectoryValue,setIsDirectoryValue] = useState(true);
	const DirectoryList = ({data,initial,getIndex}) => {
      return (
        <ul className="list-group" id="treeViewd">
          {
            data.map((d, index) => {
            let dData = {}
            if(initial===true){
              dData = d;//.documents;          
            }else{
              dData = d;
            }
            let checkedVal = false;
            if(directoryValue.value!==null && directoryValue.value === d.id){checkedVal = true}
            if(d.id!==''){
                return (
                  <li className="roles_Setup list-group-item p-1">
                    <span className="mr-2">
                      <Icons iconType="Folder" />
                    </span>
                    <label className="form-radio-label">
                      <input checked={checkedVal} onClick={e=>setDirectoryHandler(dData)} className="form-radio-input" type="radio" name="optionsRadios" value="" /> <span className="form-radio-sign">{dData.name}</span>
                    </label>              
                  {dData.documents && <DirectoryList data={dData.documents} initial={false} getIndex={index} />}
                  </li>
                );  
            }            
            })
          }
        </ul>
      );
    }

    const setDirectoryHandler = (d) => {
      // console.log('setDirectoryHandler',d)
      //setDirectoryValue(d.id)
      setDirectoryValue({
        name:d.name,
        value:d.id
      })
      if(d.type!==null && d.type!==undefined){
        setIsDirectoryValue(false);  
      }else{
        setIsDirectoryValue(true);
      }
      
    }

    const saveValueHandler = () => {
      const {documentValueHandler} = props;
      let updateValue = {
          name:directoryValue.name,
          value:directoryValue.value,
          is_directory:isDirectoryValue,
        }
        documentValueHandler(updateValue);
        // props.setDirectoryFieldDetails({},false);
    }
  console.log(documentValue);
	return(
		<Modal dialogClassName="modal-dialog modal-dialog modal-xl height-auto" show={isModalOpen} onHide={toggleDirectory}>
              <Modal.Header>
                <h5 className="modal-title secondary_color pl-2 mb-0"> Upload Files </h5> 
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="card card-transparent">
                      <div className="card-header p-0">
                        <div className="card-title">
                          Choose Directory or Files
                        </div>
                      </div>
                      <div className="card-body">
                        <DirectoryList data={documentList} initial={true} getIndex={0} />                        
                      </div>
                    </div>
                  </div>
                </div>   
              </Modal.Body>
              <Modal.Footer>
                  <a className="btn btn-border border-default mr-2" data-dismiss="modal" onClick={toggleDirectory}> Cancel </a>                 
                  <a className="btn primary_bg" onClick={saveValueHandler}>Save</a>                                                    
              </Modal.Footer>
            </Modal>
	)
}

export default DirectoryMapping;